// Utilidades de filtrado y ordenamiento para todas las tablas de BeepMX

import React, { useState } from 'react';

export function ordenarRegistros(registros, campo, direccion) {
  if (!campo) return registros;
  return [...registros].sort((a, b) => {
    let va = a[campo]; let vb = b[campo];
    if (va === undefined || va === null) va = '';
    if (vb === undefined || vb === null) vb = '';
    if (typeof va === 'number' && typeof vb === 'number') return direccion === 'asc' ? va - vb : vb - va;
    if (typeof va === 'string') va = va.toLowerCase();
    if (typeof vb === 'string') vb = vb.toLowerCase();
    if (va < vb) return direccion === 'asc' ? -1 : 1;
    if (va > vb) return direccion === 'asc' ? 1 : -1;
    return 0;
  });
}

export function filtrarPorTexto(registros, busqueda, campos) {
  if (!busqueda) return registros;
  const q = busqueda.toLowerCase();
  return registros.filter(r =>
    campos.some(campo => {
      const val = r[campo];
      if (!val) return false;
      return String(val).toLowerCase().includes(q);
    })
  );
}

export function filtrarPorFecha(registros, campo, tipo) {
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  const finSemana = new Date(hoy);
  finSemana.setDate(hoy.getDate() + 7);
  const finMes = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);

  return registros.filter(r => {
    if (!r[campo]) return false;
    const fecha = new Date(r[campo]);
    switch (tipo) {
      case 'hoy': return fecha.toDateString() === hoy.toDateString();
      case 'semana': return fecha >= hoy && fecha <= finSemana;
      case 'mes': return fecha >= hoy && fecha <= finMes;
      case 'vencidos': return fecha < hoy;
      case 'proximos': return fecha >= hoy && fecha <= finSemana;
      default: return true;
    }
  });
}

export function useOrden(campoInicial = '', direccionInicial = 'asc') {
  const [orden, setOrden] = useState({ campo: campoInicial, dir: direccionInicial });
  const toggleOrden = (campo) => {
    setOrden(prev => ({
      campo,
      dir: prev.campo === campo && prev.dir === 'asc' ? 'desc' : 'asc'
    }));
  };
  return [orden, toggleOrden];
}

export function HeaderOrdenable({ label, campo, orden, onOrdenar, style = {} }) {
  const activo = orden.campo === campo;
  return (
    <th
      onClick={() => onOrdenar(campo)}
      style={{
        padding: '12px 16px',
        textAlign: 'left',
        fontSize: '11px',
        fontWeight: '600',
        color: activo ? '#2f5f9e' : '#5e666e',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        cursor: 'pointer',
        userSelect: 'none',
        whiteSpace: 'nowrap',
        background: activo ? '#f0f7ff' : 'transparent',
        ...style
      }}
    >
      {label}
      <span style={{ marginLeft: '4px', opacity: activo ? 1 : 0.3 }}>
        {activo ? (orden.dir === 'asc' ? '↑' : '↓') : '↕'}
      </span>
    </th>
  );
}

export function BarraBusqueda({ value, onChange, placeholder = 'Buscar...' }) {
  return (
    <div style={{ position: 'relative', marginBottom: '12px' }}>
      <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', fontSize: '14px', color: '#5e666e', pointerEvents: 'none' }}>{'🔍'}</span>
      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          width: '100%',
          padding: '10px 12px 10px 36px',
          border: '1px solid #e0e0e0',
          borderRadius: '10px',
          fontSize: '13px',
          fontFamily: "'Poppins', sans-serif",
          background: '#ffffff',
          boxSizing: 'border-box',
          outline: 'none',
          color: '#4e5357',
        }}
      />
      {value && (
        <span
          onClick={() => onChange('')}
          style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', fontSize: '14px', color: '#5e666e' }}
        >{'✕'}</span>
      )}
    </div>
  );
}

export function FiltrosRapidos({ opciones, activo, onChange }) {
  return (
    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '12px' }}>
      {opciones.map(op => (
        <button
          key={op.value}
          onClick={() => onChange(activo === op.value ? '' : op.value)}
          style={{
            padding: '5px 14px',
            borderRadius: '20px',
            border: 'none',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: '600',
            fontFamily: "'Poppins', sans-serif",
            background: activo === op.value ? '#2f5f9e' : '#ffffff',
            color: activo === op.value ? '#ffffff' : '#4e5357',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            transition: 'all 0.15s',
          }}
        >
          {op.label} {op.count !== undefined && (
            <span style={{ opacity: 0.7, fontWeight: '400' }}>({op.count})</span>
          )}
        </button>
      ))}
    </div>
  );
}

export function ContadorResultados({ total, filtrados }) {
  if (total === filtrados) return (
    <span style={{ fontSize: '12px', color: '#5e666e', fontFamily: "'Poppins', sans-serif" }}>
      {total} registros
    </span>
  );
  return (
    <span style={{ fontSize: '12px', color: '#5e666e', fontFamily: "'Poppins', sans-serif" }}>
      Mostrando <strong>{filtrados}</strong> de {total} registros
    </span>
  );
}

export function BarraPestanas({ tabs, activo, onChange }) {
  return (
    <div style={{ background: '#f3f4f4', borderRadius: '8px 8px 0 0', padding: '4px 4px 0', marginBottom: '16px', overflowX: 'auto', display: 'flex', gap: '2px', borderBottom: '2px solid #e0e0e0' }}>
      {tabs.map(t => {
        const esActivo = activo === t.key;
        return (
          <button
            key={t.key}
            onClick={() => onChange(t.key)}
            style={{
              padding: '12px 20px',
              background: esActivo ? '#ffffff' : 'transparent',
              border: 'none',
              borderBottom: esActivo ? '3px solid #2f5f9e' : '3px solid transparent',
              borderRadius: '8px 8px 0 0',
              marginBottom: '-2px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: '600',
              color: esActivo ? '#2f5f9e' : '#5e666e',
              fontFamily: "'Poppins', sans-serif",
              whiteSpace: 'nowrap',
              boxShadow: esActivo ? '0 -1px 4px rgba(0,0,0,0.06)' : 'none',
              transition: 'all 0.15s',
              flexShrink: 0,
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
